import { CircleCheck } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const enrollmentStateOptionsManual: ComboboxFilterOption<string>[] = [
  { label: 'Member Confirmed', value: 'member_confirmed' },
  { label: 'Submission Processing', value: 'submission_processing' },
  { label: 'Completed', value: 'completed' },
  { label: 'Canceled', value: 'canceled' },
  { label: 'Member Cart', value: 'member_cart' },
]
const enrollmentStateOptionsAutomated: ComboboxFilterOption<string>[] = [
  { label: 'Carrier Processing', value: 'carrier_processing' },
]

const enrollmentStateOptions = [
  ...enrollmentStateOptionsManual,
  ...enrollmentStateOptionsAutomated,
]

const EnrollmentStateFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredManualOptions = enrollmentStateOptionsManual?.filter(
    filterByLabelAndValueCallback(query)
  )
  const filteredAutomatedOptions = enrollmentStateOptionsAutomated?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Manual', options: filteredManualOptions || [] },
          { groupLabel: 'Automated', options: filteredAutomatedOptions || [] },
        ]}
        placeholder='Search states to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={enrollmentStateOptions || []}
          noSelectionText='Enrollment State'
          pluralIdentifier='enrollment states'
        >
          <CircleCheck size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EnrollmentStateFilter
